// extracted by mini-css-extract-plugin
module.exports = {"item":"Language_item__E8Ni6","text":"Language_text__12bAT","checkmark":"Language_checkmark__2v0yB"};